const toggleStateStats = (state) => {
    const stats = document.getElementById(`statsByState-${state}`);
    const catchAll = document.getElementById('statsByState-all');
    const nationwideData = document.getElementById('statsByState-nationwide');

    if (nationwideData) nationwideData.classList.remove('is-active');

    if (stats) {
        stats.classList.toggle('is-active');
    } else {
        catchAll.classList.toggle('is-active');
    }
};

const showNationwide = () => {
    const activeStates = Array.from(document.querySelectorAll('.stats-by-state .is-active'));
    const nationwideData = document.getElementById('statsByState-nationwide');

    activeStates.forEach(state => state.classList.remove('is-active'));
    if (nationwideData) nationwideData.classList.add('is-active');
};

export default (() => {
    if ('simplemaps_australiamap' in window) {
        window.simplemaps_australiamap.hooks.over_state = (id) => {
            toggleStateStats(id.toLowerCase());
        };
        window.simplemaps_australiamap.hooks.out_state = () => {
            showNationwide();
        };
        showNationwide();
    }
})();
